import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';
import {PurchasePayment, IPurchasePayment} from 'app/blocks/model/purchase-payment.model';
import {PurchasePaymentService} from 'app/blocks/service/api/purchase-payment.service';

@Injectable({
    providedIn: 'root'
})
export class PurchasePaymentResource extends AbstractEntityResource<IPurchasePayment> {
    constructor(purchasePaymentService: PurchasePaymentService, router: Router) {
        super(
            Resource.PURCHASE_PAYMENTS,
            purchasePaymentService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.PURCHASE_PAYMENTS, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.PURCHASE_PAYMENTS),
            (entity?) => new PurchasePayment(entity),
            (entity) => entity.id,
            'share'
        );
    }
}
